export const AvailableBrands = [
    'amex',
    'dinners',
    'dinersclub',
    'visa',
    'mastercard',
    'maestro',
    'discover',
    'hipercard',
    'elo',
    'jcb',
    'aura',
    'electron',
    'unionpay',
    'laser',
    'hiper',
    'visaelectron'
];



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/enums/AvailableBrands.ts